import './HomeAbout.css';
import homeAboutImage from '../../../assets/images/home__about-image.webp';
import homeAboutIcon1 from '../../../assets/icons/homeAboutIcon1.png';
import homeAboutIcon2 from '../../../assets/icons/homeAboutIcon2.png';
import homeAboutIcon3 from '../../../assets/icons/homeAboutIcon3.png';
import homeAboutIcon4 from '../../../assets/icons/homeAboutIcon4.png';

const HomeAbout = () => {
  return (
    <section className='home__about'>
        <div className="home__about-content">
            <div className="home__about-content-texts">
                <h2 className="home__about-content-title mont-m">
                Наше виробництво
                </h2>
                <p className="home__about-content-text int-r-21">
                У портфоліо Доманівського маслосирзаводу — дві торгівельні марки: відома понад 20 років ТМ «Pastoral», і молода демократична ТМ «Мумуля».
                </p>
                <p className="home__about-content-text int-r-21">
                Якщо хочеться провести вечір вишукано — обирайте Pastoral: авторські сири, десерти, йогурти, вершкове масло за французькою рецептурою. А коли потрібно смачно і корисно нагодувати всю родину — приєднуйтесь до спільноти Мумуля.
                </p>
                <p className="home__about-content-text int-r-21">
                Продукція заводу - натуральна, перевірена, безпечна для дітей, на ній виросло не одне покоління українців — адже ми постачаємо молочні продукти в дитячі садки, школи, лікарні та санаторії.
                </p>
            </div>
                <img src={homeAboutImage} alt="pastoral логотип" className="home__about-content-image" />
        </div>
        <div className="home__about-cards">
            <div className="home__about-card">
                <img src={homeAboutIcon1} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Фермерська продукція</p>
            </div>
            <div className="home__about-card second">
                <img src={homeAboutIcon2} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">20 років на ринку</p>
            </div>
            <div className="home__about-card">
                <img src={homeAboutIcon3} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Досвід роботи з HoReCa</p>
            </div>
            <div className="home__about-card">
                <img src={homeAboutIcon4} alt="Фермерська продукція" className="home__about-card-image" />
                <p className="home__about-card-text int-r-21">Тендерні постачання</p>
            </div>
            
        </div>
    </section>
  )
}

export default HomeAbout